import useStore from 'reusable/mobx-store-utils'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { useAuthStore } from 'auth/AuthStore'
import WebSocketStore, { WebSocketStoreProvider } from './WebSocketStore'

export default observer(function WebSocketProvider(props: { children?: React.ReactNode }) {
   const authStore = useAuthStore()
   const wsStore = useStore((sp) => new WebSocketStore(sp), { authStore: authStore })

   return (
      <WebSocketStoreProvider store={wsStore}>
         {props.children}
      </WebSocketStoreProvider>
   )
})
